import { createPrivilegeObject } from "utils/privileges/privilegesMapper"

const editedTodoLogTransformer = response => {
  const transformedData = data => ({
    ...data,
    ...data?.InternalInquiry,
    deadlineCounters: {
      overdue: data?.deadlineCounters?.overdue,
      today: data?.deadlineCounters?.today,
      tomorrow: data?.deadlineCounters?.tomorrow,
      week: data?.deadlineCounters?.week,
      all: data?.deadlineCounters?.all,
    },
    TaskPerformed: data?.Status,
    InternalInquiry: {
      ...data?.InternalInquiry,
      Client: {
        ...data?.InternalInquiry?.Client,
        inquiryCount: data?.inquiryCount,
      },
    },
    privileges: createPrivilegeObject(data?.privileges),
    updatedByAI: data?.LogUpdatedBy?.id === -1,
  })

  return response?.map(res => transformedData(res))
}

export default editedTodoLogTransformer
